import { AlertController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthoGuard implements CanActivate {

  constructor(private alertController: AlertController){

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // const userData:any = this.parseJwt(localStorage.getItem('token-google'));
    // if (userData.scope == 'openid') {
    //   console.log(route)
    // }
    console.log('route', route);
    console.log('state', state);
    if (state.url.indexOf('/login') === -1 && state.url !== '/') {
      const perms = JSON.parse(localStorage.getItem('perms'));
      const access = perms.find((el: any) => state.url.indexOf(el.url)>-1);
      if (access !== undefined) {
        return true;
      } else {
        this.presentAlert();
        return false;
      }
    } else {
      return true;
    }
  }

  parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: 'Access Denied',
      message: 'You don"t have permissions for this option',
      buttons: ['Got it']
    });

    await alert.present();
  }

}
